import { c as _c } from "react/compiler-runtime";
import type { TenantScope } from '@onefootprint/request-types/dashboard';
import { Tag } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import { getDecryptAccess, getDecryptOptionsByEnvironment } from '@/components/roles/utils/decrypt-access';
import { groupTenantRoleScopes } from '@/components/roles/utils/group-scopes';
import { isSandboxOnly } from '@/components/roles/utils/scope-environments';
import DecryptOptions from '../decrypt-options';
import VaultProxyOptions from '../vault-proxy-options';
export type ScopesProps = {
  scopes: TenantScope[];
};
const Scopes = t0 => {
  const $ = _c(20);
  const {
    scopes
  } = t0;
  const {
    t
  } = useTranslation("roles");
  let t1;
  let t2;
  let t3;
  let t4;
  let vaultProxyOptions;
  if ($[0] !== scopes || $[1] !== t) {
    t4 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const {
        isAdmin,
        basicScopes,
        vaultProxyOptions: t5
      } = groupTenantRoleScopes(scopes);
      vaultProxyOptions = t5;
      const {
        sandbox,
        production
      } = getDecryptOptionsByEnvironment(getDecryptAccess(scopes));
      const decryptLabel = t(_temp);
      const getDecryptTags = () => {
        if (!production.length) {
          return [{
            label: t(_temp2, {
              scope: decryptLabel
            }),
            options: sandbox
          }];
        }
        if (sandbox.length === production.length && sandbox.every(option => production.includes(option))) {
          return [{
            label: decryptLabel,
            options: sandbox
          }];
        }
        return [{
          label: t(_temp3),
          options: sandbox
        }, {
          label: t(_temp4),
          options: production
        }];
      };
      if (isAdmin) {
        let t6;
        if ($[7] !== t) {
          t6 = t(_temp5);
          $[7] = t;
          $[8] = t6;
        } else {
          t6 = $[8];
        }
        let t7;
        if ($[9] !== t6) {
          t7 = <span>{t6}</span>;
          $[9] = t6;
          $[10] = t7;
        } else {
          t7 = $[10];
        }
        t4 = t7;
        break bb0;
      }
      t1 = "flex flex-row flex-wrap items-center gap-1 py-2";
      let t6;
      if ($[11] !== t) {
        t6 = scope => <Tag key={scope.kind}>{(() => {
            const translation = t($_4 => $_4.scopes[scope.kind]);
            const label = typeof translation === "string" ? translation : "";
            return isSandboxOnly(scope) ? t(_temp6, {
              scope: label
            }) : label;
          })()}</Tag>;
        $[11] = t;
        $[12] = t6;
      } else {
        t6 = $[12];
      }
      t2 = basicScopes.map(t6);
      t3 = getDecryptTags().map(_temp7);
    }
    $[0] = scopes;
    $[1] = t;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = vaultProxyOptions;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    vaultProxyOptions = $[6];
  }
  if (t4 !== Symbol.for("react.early_return_sentinel")) {
    return t4;
  }
  let t5;
  if ($[13] !== vaultProxyOptions) {
    t5 = <VaultProxyOptions options={vaultProxyOptions} />;
    $[13] = vaultProxyOptions;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t1 || $[16] !== t2 || $[17] !== t3 || $[18] !== t5) {
    t6 = <div className={t1}>{t2}{t3}{t5}</div>;
    $[15] = t1;
    $[16] = t2;
    $[17] = t3;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
};
export default Scopes;
function _temp($) {
  return $.scopes.decrypt_fields_one;
}
function _temp2($_0) {
  return $_0.scopes.sandboxOnly;
}
function _temp3($_1) {
  return $_1.scopes.decryptInSandbox;
}
function _temp4($_2) {
  return $_2.scopes.decryptInProduction;
}
function _temp5($_3) {
  return $_3.scopes.admin;
}
function _temp6($_5) {
  return $_5.scopes.sandboxOnly;
}
function _temp7(t0) {
  const {
    label: label_0,
    options
  } = t0;
  return <DecryptOptions key={label_0} label={label_0} options={options} />;
}